<template>
  <div class="cbn-wrap">
    <div class="cbn-bar">

      <button class="cbn-item" :class="{ 'cbn-active': isHome }" @click="goHome">
        <home-icon class="cbn-icon" />
        <span class="cbn-label">Home</span>
      </button>

      <button class="cbn-item" :class="{ 'cbn-active': isActivity }" @click="goActivity">
        <clipboard-list-icon class="cbn-icon" />
        <span class="cbn-label">Activity</span>
      </button>

      <button class="cbn-item" :class="{ 'cbn-active': activeChat }" @click="openChat">
        <message-circle-icon class="cbn-icon" />
        <span class="cbn-label">Chat</span>
      </button>

      <button class="cbn-item" :class="{ 'cbn-active': activeReservation }" @click="openReservation">
        <book-open-icon class="cbn-icon" />
        <span class="cbn-label">My Stay</span>
      </button>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Home as HomeIcon, ClipboardList as ClipboardListIcon, MessageCircle as MessageCircleIcon, BookOpen as BookOpenIcon } from 'lucide-vue'

  export default {
    name: 'ConciergeBottomNav',

    components: { HomeIcon, ClipboardListIcon, MessageCircleIcon, BookOpenIcon },

    props: {
      activeChat:        { type: Boolean, default: false },
      activeReservation: { type: Boolean, default: false },
    },

    computed: {
      ...mapGetters(['getMerchant']),

      isHome()     { return this.$route.name === 'ConciergeMainPage' },
      isActivity() { return this.$route.name === 'ConciergeHistory' },
    },

    methods: {
      goHome() {
        if (!this.isHome) this.$router.push({ name: 'ConciergeMainPage' })
      },
      goActivity() {
        if (!this.isActivity) this.$router.push({ name: 'ConciergeHistory' })
      },
      openChat() {
        if (this.isHome) {
          this.$emit('chat')
        } else {
          this.$router.push({ name: 'ConciergeMainPage', query: { open: 'chat' } })
        }
      },
      openReservation() {
        if (this.isHome) {
          this.$emit('reservation')
        } else {
          this.$router.push({ name: 'ConciergeMainPage', query: { open: 'reservation' } })
        }
      },
    },
  }
</script>

<style scoped>
.cbn-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1050;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.cbn-bar {
  width: 100%;
  max-width: 480px;
  display: flex;
  background: #fff;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.08);
  padding-bottom: env(safe-area-inset-bottom);
  pointer-events: all;
}

.cbn-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #9CA3AF;
  padding: 0;
  gap: 3px;
  transition: color 0.15s;
  -webkit-tap-highlight-color: transparent;
}

.cbn-item.cbn-active {
  color: var(--merchant-primary-color, #16a34a);
}

.cbn-icon {
  width: 22px;
  height: 22px;
}

.cbn-label {
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/ConciergeBottomNav.vue